import React, { useEffect, useRef } from 'react';
import './Modal.scss';

export interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
    size?: 'sm' | 'md' | 'lg';
    overlayClassName?: string;
    modalClassName?: string;
    contentClassName?: string;
}

export const Modal: React.FC<ModalProps> = ({
    isOpen,
    onClose,
    title,
    children,
    size = 'md',
    overlayClassName = '',
    modalClassName = '',
    contentClassName = '',
}) => {
    // onClose를 ref로 저장하여 의존성 문제 해결
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onCloseRef.current();
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className={`modal-overlay ${overlayClassName}`.trim()} onClick={onClose}>
            <div
                className={`modal modal--${size} ${modalClassName}`.trim()}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                {title && (
                    <div className="modal__header">
                        <h2 className="modal__title">{title}</h2>
                        <button type="button" className="modal__close" onClick={onClose} aria-label="닫기">
                            ×
                        </button>
                    </div>
                )}
                <div className={`modal__content ${contentClassName}`.trim()}>{children}</div>
            </div>
        </div>
    );
};
